/**
 * Adaptador client → POS_PLANS_SSOT (POS-PLANS-SSOT-001B-CLOSURE-001).
 * API publica sin cambios; no definir literales de plan aqui.
 */
import ssot from 'pos-plans-ssot';

export const PLAN_TIERS = ssot.PLAN_TIERS;
export const PLAN_LABELS_ES = ssot.PLAN_LABELS_ES;
export const PLAN_LEGACY_LABELS_ES = ssot.PLAN_LEGACY_LABELS_ES;
export const PLAN_COMMERCIAL_NAMES = ssot.PLAN_COMMERCIAL_NAMES;
export const PLAN_PRICES_ARS = ssot.PLAN_PRICES_ARS;
export const PLAN_MODULE_KEYS = ssot.PLAN_MODULE_KEYS;
export const PLAN_COMMERCIAL_META = ssot.PLAN_COMMERCIAL_META;
export const BILLING_CYCLE_DAYS = ssot.BILLING_CYCLE_DAYS;
export const TRIAL_DAYS = ssot.TRIAL_DAYS;
export const TRIAL_POLICY = ssot.TRIAL_POLICY;
export const getTrialEndsAtDate = ssot.getTrialEndsAtDate;
export const DEMO_HOURS = ssot.DEMO_HOURS;

export function normalizeLicensePlan(raw) {
  return ssot.normalizeLicensePlan(raw);
}

export function normalizePlan(raw) {
  return ssot.normalizePlan(raw);
}

export function defaultPlanPrices() {
  return ssot.defaultPlanPrices();
}

export function getCommercialPlanName(rawPlan) {
  return ssot.getCommercialPlanName(rawPlan);
}

export function resolvePlanPrices(firestorePlanPrices, legacyMonthlyBasic) {
  return ssot.resolvePlanPrices(firestorePlanPrices, legacyMonthlyBasic);
}

export function isLegacySilentPlanPrice(tier, value) {
  return ssot.isLegacySilentPlanPrice(tier, value);
}

export function getModulePresetForPlan(rawPlan) {
  return ssot.getModulePresetForPlan(rawPlan);
}

export function getPlanCommercialMeta(rawPlan) {
  return ssot.getPlanCommercialMeta(rawPlan);
}